// extracted by mini-css-extract-plugin
export default {"header":"MultiTicketModal_header__VaubR","title":"MultiTicketModal_title__-porS","body":"MultiTicketModal_body__mydKO","actionWrapper":"MultiTicketModal_actionWrapper__gEmTT"};